// this was copied from here: https://stackoverflow.com/a/58989019/1958910

import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
  selector: '[appMax]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMaxDirective, multi: true}]
})
export class CustomMaxDirective implements Validator {

  @Input() appMax: number;

  validate(c: FormControl): {[key: string]: any} {
      return ( c.value > this.appMax) ? {appMax: true} : null;
  }
}
